import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from "@angular/forms";
import { Utilities } from 'src/app/models/utilities';
import { AppCoreService } from 'src/app/services/app-core.service';

@Component({
  selector: 'app-bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.scss']
})
export class BankDetailsComponent implements OnInit, AfterViewInit {
  @Input() formGroupName: string;

  bankDetailsForm: FormGroup;
  useEnterKey: boolean;

  firmList: any[] = [{ name: 'GOVT' }, { name: 'NON GOVT' }];

  constructor(
    private rootFormGroup: FormGroupDirective,
    private appCoreService: AppCoreService,
    private utilities: Utilities
  ) {}

  ngOnInit(): void {
    this.bankDetailsForm = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
    this.useEnterKey = !this.appCoreService.GetUserData().metaInfo.tabbasedtemplate;
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.bankDetailsForm) : null;
  }

  // Method to check if the control exists
  hasControl(controlName: string): boolean {
    return this.bankDetailsForm?.get(controlName) !== null;
  }
}
